import axios from 'axios';

export function getTimelineEntries() {
    return axios.get('api/warehousing/timeline');
}

export function createCustomNote(note) {
    return axios.post('api/warehousing/timeline/custom-note', {note});
}
